module.exports = __webpack_public_path__ + "img/ending_arrow_focus.0ccd894c.svg";